import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const TeamLeadsHub = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default TeamLeadsHub